export function normalizeMessageText(value: string): string {
  const doc = new DOMParser().parseFromString(value, 'text/html');
  return (doc.body.textContent ?? '')
    .replace(/\u00A0/g, ' ')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .replace(/\r\n/g, '\n')
    .normalize('NFC')
    .replace(/\s+$/g, '')
    .trim();
}

export function validateMessageLength(value: string): {
  isValid: boolean;
  error?: string;
} {
  const text = normalizeMessageText(value);

  if (text.length === 0) {
    return { isValid: false, error: 'Email body is required' };
  }

  if (text.length > 2500) {
    return {
      isValid: false,
      error:
        'You have exceeded the 2500-character limit. Please reduce the length to continue.'
    };
  }

  return { isValid: true };
}
